import { useGate } from "statsig-react";

export const PROFILE_AS_HOME_GATE = "enable_profile_as_home_page";

/**
 * Controls the "profile as home" rollout.
 *
 * When the gate is on, `ProfilePage` becomes the app home (`/`) and the jobs
 * table moves to `/labeling`. When off, the home page stays the jobs table at
 * `/` and the profile page is not reachable at any route.
 */
export function useProfileHome() {
  const { value: profileAsHome, isLoading } = useGate(PROFILE_AS_HOME_GATE);
  return {
    profileAsHome,
    isLoading,
    /** Where the jobs table lives: "/labeling" when profile-as-home is on, else "/". */
    jobsPath: profileAsHome ? "/labeling" : "/",
  };
}
